import { useQuery } from '@tanstack/react-query'

import apiClient from './client'

// Status-Aufschluesselung der Freigabe-Queues (GET .../count, Huelle {data:{...}}).
// Alle Schluessel sind immer vorhanden (0 statt fehlend).
export interface QueueCounts {
  'cancel-requests': { pending: number; approved: number; applied: number; rejected: number; withdrawn: number }
  'dsgvo-requests': { pending: number; processing: number; done: number; failed: number }
  'terminate-reviews': { pending: number; approved: number; rejected: number }
  'license-reset-requests': { pending: number; approved: number; rejected: number; done: number }
}

export type QueueKind = keyof QueueCounts

// Der Key ['<kind>','count'] liegt unter dem Listen-Praefix ['<kind>'], so dass
// jede Mutation, die die Liste invalidiert, auch den Zaehler neu laedt.
export function useQueueCounts<K extends QueueKind, R = QueueCounts[K]>(
  kind: K,
  opts: { refetchInterval?: number; select?: (c: QueueCounts[K]) => R } = {},
) {
  return useQuery({
    queryKey: [kind, 'count'],
    queryFn: async () => {
      const res = await apiClient.get<{ data: QueueCounts[K] }>(`/api/v1/${kind}/count`)
      return res.data.data
    },
    refetchInterval: opts.refetchInterval ?? 60_000,
    retry: false,
    select: opts.select,
  })
}
